import { NgModule } from '@angular/core';
import { ApolloModule, APOLLO_OPTIONS } from 'apollo-angular';
import { HttpLinkModule, HttpLink } from 'apollo-angular-link-http';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { WebSocketLink } from 'apollo-link-ws';
import { HttpHeaders } from '@angular/common/http';
import { split } from 'apollo-link';
import { onError } from 'apollo-link-error';
import { getMainDefinition } from 'apollo-utilities';
import { config } from '@app/app.config';

const uri = 'ws://localhost:3001/graphql'; // <-- add the URL of the GraphQL server here
export function createApollo(httpLink: HttpLink) {
  // Create a WebSocket link:

  const http = httpLink.create({
    uri: `${config.httpURL}${config.pathToGraphQL}`,
    headers: new HttpHeaders().set(
      'Authorization',
      `Bearer ${localStorage.getItem('access_token')}`
    )
  });

  const logoutLink = onError(error => {

    // @ts-ignore
    if (error.response.errors[0].message.statusCode === 401)
      if (
        window.location.pathname !== '/auth/login' &&
        !/\/events.*/.test(window.location.pathname)
      ) {
        window.location.pathname = '/auth/login';
      }
  });

  const ws = new WebSocketLink({
    uri: `${config.wsURL}${config.pathToGraphQL}`,
    options: {
      reconnect: true,
      connectionParams: {
        headers: {
          authorization: `Bearer ${localStorage.getItem('access_token')}`
        }
      }
    }
  });

  const link = split(
    // split based on operation type
    ({ query }) => {
      // @ts-ignore
      const { kind, operation } = getMainDefinition(query);
      return kind === 'OperationDefinition' && operation === 'subscription';
    },
    ws,
    http
  );

  return {
    link,
    defaultOptions: {
      watchQuery: {
        fetchPolicy: 'cache-and-network',
        errorPolicy: 'all'
      },
      mutate: {
        errorPolicy: 'all'
      }
    },
    cache: new InMemoryCache()
  };
}

@NgModule({
  exports: [ApolloModule, HttpLinkModule],
  providers: [
    {
      provide: APOLLO_OPTIONS,
      useFactory: createApollo,
      deps: [HttpLink]
    }
  ]
})
export class GraphQLModule {}
